import styled from 'styled-components';
import Loading from './LoadingCircle';
import ReactDOM from 'react-dom';

function LoadingModal() {
  const modalContent = (
    <ModalOverlay>
      <Loading />
    </ModalOverlay>
  );

  return ReactDOM.createPortal(modalContent, document.body);
}

export default LoadingModal;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #cdcdcd85;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
`;
